module.exports = __webpack_public_path__ + "img/$pac.4dfc3565.svg";